import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { tap } from 'rxjs';
import { Action } from 'src/app/core/models/action.model';
import { AllDoneDialogComponent } from './components/all-done-dialog/all-done-dialog.component';
import { GuideService } from './services/guide.service';

@Component({
  selector: 'app-guide',
  templateUrl: './guide.component.html',
  styleUrls: ['./guide.component.scss'],
})
export class GuideComponent {
  claimId?: string;

  selectedActionIndex = 0;

  actions?: Action[];
  loaded: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private guideService: GuideService,
    private router: Router,
    private dialog: MatDialog
  ) {
    this.route.params
      .pipe(
        tap(async (params) => {
          this.claimId = params['claimId'];
          if (!(await this.guideService.checkIfUserMustAccessGuide())) {
            this.router.navigateByUrl('/client/home');
          }
          this.loadActions();
        })
      )
      .subscribe();
  }

  async loadActions() {
    this.loaded = false;
    this.actions = this.guideService.requirementsFormClaim!;
    console.log('[OA] loadActions', this.actions);

    // compute starting index: first action not marked as DONE/SIGNED/PR 'DONE'
    if (this.actions && this.actions.length > 0) {
      const idx = this.actions.findIndex(
        (a) =>
          !(
            a.ac_status === 'DONE' ||
            a.ac_status === 'PROCESSING' ||
            a.ac_status === 'SUBMITTED' ||
            a.ac_status === 'SIGNED'
          )
      );
      console.log('First incomplete action index', idx);
      this.selectedActionIndex = idx === -1 ? 0 : idx;
    }

    this.loaded = true;
  }

  onComplete() {
    if (!this.actions) {
      return;
    }

    const nextIndex = this.selectedActionIndex + 1;
    if (this.actions[nextIndex] != null) {
      this.selectedActionIndex = nextIndex;
    } else {
      this.openSuccessModal();
    }
  }

  openSuccessModal() {
    this.guideService.setSkipCheckTrue();

    const dialog = this.dialog.open(AllDoneDialogComponent);

    dialog.afterClosed().subscribe(() => {
      this.router.navigateByUrl('client/home');
    });
  }
}
